export const classes = {
  wrapper: 'flex items-center group-data-[compact]/tile:gap-0',
  icon: 'text-2xl text-taupe-2 dark:text-mauve-2 group-data-[compact]/tile:text-lg',
  activeIcon: 'text-brand-accent dark:text-brand-accent-dark',
  divider: 'mx-2 group-data-[compact]/tile:mx-1',
  deleteButton:
    'text-taupe-2 hover:text-red-3 transition-colors dark:text-mauve-2 dark:hover:text-red-2',
  deleteIcon: 'text-inherit',
};
